export { default } from './DtrLogs.js';